import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  props: {
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {},
      timer1: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = recursionCopy(this.styleObj);
    });
  },
  methods: {
    imgClick(val, id) {
      this.form.controlsComponentsMark = val;
      this.form.controlsComponentsId = id;
      this.changeFun();
    },
    changeFun() {
      console.log(5555);
      this.$emit('itemChange', this.form);
    },
    changeClausFun(e) {
      this.form.isHiddenClause = e.target.checked;
      if (e.target.checked) {
        this.form.format = 'pdf';
        this.form.limit = 4;
        this.form.time = '';
      }
      this.changeFun();
    },
    changeIdentificationFun(e) {
      this.form.isIdentification = e.target.checked;
      this.changeFun();
    },
    changeInsuredFun(e) {
      this.form.isAddInsured = e.target.checked;
      this.form.insuredNum = 2;
      this.changeFun();
    },
    blurFun() {
      if (!this.form.insuredNum) {
        this.form.insuredNum = 2;
      }
      this.changeFun();
    },
    blurFun2() {
      this.form.time = this.form.time || '';
      this.changeFun();
    }
  }
};